import { call, getContext, put, takeLatest } from "redux-saga/effects";

import {
  getContentRequestMockDataFailure,
  getContentRequestMockDataSuccess,
} from "./actions";

import { getContentRequestMockDataActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";

const getContentRequestMockDataAsync = ({
  ContentRequestService,
  username,
}) => {
  if (!ContentRequestService) {
    return;
  }

  return ContentRequestService.getContentRequestMockData(username);
};

function* getContentRequestMockData({ payload }) {
  try {
    const { username } = payload;

    const { ContentRequestService } = yield getContext(CONTEXT.SERVICES);

    const { data } = yield call(getContentRequestMockDataAsync, {
      ContentRequestService,
      username,
    });

    yield put(getContentRequestMockDataSuccess(data));
  } catch (error) {
    yield put(getContentRequestMockDataFailure(error));
  }
}

export function* watchGetContentRequestMock() {
  yield takeLatest(
    getContentRequestMockDataActionTypes.request,
    getContentRequestMockData,
  );
}
